export default __webpack_public_path__ + "static/media/Group112.5fbe95a1.png";